import React from 'react';

const Footer = ({ fixed = false }) => (
  <footer className={`app-footer${fixed ? ' app-footer--fixed' : ''}`}>
    <span>Created by <a href="https://keshonect.co.ke/" target="_blank" rel="noopener noreferrer">KESHONECT</a></span>
  </footer>
);

export default Footer;
